import { useAutoAnimate } from "@formkit/auto-animate/react";
import React from "react";
import { Merchandise, ProductObject } from "types";
import { MerchandiseTile } from "./Merchandise/MerchandiseTile";
import { NoProductsAlert } from "./NoProductsAlert";

interface MerchandiseListProps {
    merchandises: Merchandise[];
    isLoading: boolean;
    isFiltered: boolean;
}

export const MerchandiseList = ({ merchandises, isLoading, isFiltered }: MerchandiseListProps) => {
    const [animationParent] = useAutoAnimate<HTMLDivElement>();

    if (isLoading) {
        return <div>Loading...</div>;
    }

    if (merchandises.length === 0 && isFiltered) {
        return (
            <div className="py-15 px-10">
                <NoProductsAlert isListFiltered object={ProductObject.WARE} />
            </div>
        );
    }

    return (
        <div className="py-15 px-10">
            {merchandises.length > 0 ? (
                <div
                    ref={animationParent}
                    className="grid grid-cols-2 gap-y-10 gap-x-12"
                    data-testid="merchandise-list"
                >
                    {merchandises.map((merchandise) => (
                        <MerchandiseTile key={merchandise.id} merchandise={merchandise} />
                    ))}
                </div>
            ) : (
                <NoProductsAlert object={ProductObject.WARE} />
            )}
        </div>
    );
};
